'use strict';

exports.__esModule = true;

exports.default = function () {
  var child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      store = _ref.store;

  return typeof child === 'function' ? child(store) : child;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-kindergarten/lib/vue-kindergarten/getChild.js
// module id = UPxx
// module chunks = 40